import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageview, trackPhoneClick } from '../utils/siteTracking';

export const SiteTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    recordPageview(pathname);
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest && e.target.closest('a[href^="tel:"]');
      if (link) trackPhoneClick(window.location.pathname, link.getAttribute('href'));
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
};
